export const GET_RCA = "GET_RCA";
export const GET_RCA_FAIL = "GET_RCA_FAIL";
export const GET_RCA_SUCCESS = "GET_RCA_SUCCESS";

export const GET_RCA_BY_ID = "GET_RCA_BY_ID";
export const GET_RCA_BY_ID_FAIL = "GET_RCA_BY_ID_FAIL";
export const GET_RCA_BY_ID_SUCCESS = "GET_RCA_BY_ID_SUCCESS";

export const GET_ACTION_ITEM_BY_ID = "GET_ACTION_ITEM_BY_ID";
export const GET_ACTION_ITEM_BY_ID_FAIL = "GET_ACTION_ITEM_BY_ID_FAIL";
export const GET_ACTION_ITEM_BY_ID_SUCCESS = "GET_ACTION_ITEM_BY_ID_SUCCESS";

// export const POST_RCA = "POST_RCA";
// export const POST_RCA_FAIL = "POST_RCA_FAIL";
// export const POST_RCA_SUCCESS = "POST_RCA_SUCCESS";

export const POST_FULL_RCA = "POST_FULL_RCA";
export const POST_FULL_RCA_FAIL = "POST_FULL_RCA_FAIL";
export const POST_FULL_RCA_SUCCESS = "POST_FULL_RCA_SUCCESS";

export const UPDATE_RCA_IMPACT = "UPDATE_RCA_IMPACT";
export const UPDATE_RCA_IMPACT_FAIL = "UPDATE_RCA_IMPACT_FAIL";
export const UPDATE_RCA_IMPACT_SUCCESS = "UPDATE_RCA_IMPACT_SUCCESS";

export const UPDATE_RCA_TIMELINE = "UPDATE_RCA_TIMELINE";
export const UPDATE_RCA_TIMELINE_FAIL = "UPDATE_RCA_TIMELINE_FAIL";
export const UPDATE_RCA_TIMELINE_SUCCESS = "UPDATE_RCA_TIMELINE_SUCCESS";

export const UPDATE_RCA_QUESTIONS = "UPDATE_RCA_QUESTIONS";
export const UPDATE_RCA_QUESTIONS_FAIL = "UPDATE_RCA_QUESTIONS_FAIL";
export const UPDATE_RCA_QUESTIONS_SUCCESS = "UPDATE_RCA_QUESTIONS_SUCCESS";

export const UPDATE_RCA_INCIDENT_DETAILS = "UPDATE_RCA_INCIDENT_DETAILS";
export const UPDATE_RCA_INCIDENT_DETAILS_FAIL = "UPDATE_RCA_INCIDENT_DETAILS_Fail";
export const UPDATE_RCA_INCIDENT_DETAILS_SUCCESS = "UPDATE_RCA_INCIDENT_DETAILS_SUCCESS"

export const UPDATE_RCA_HEADER_DETAILS = "UPDATE_RCA_HEADER_DETAILS";
export const UPDATE_RCA_HEADER_DETAILS_FAIL = "UPDATE_RCA_HEADER_DETAILS_FAIL";
export const UPDATE_RCA_HEADER_DETAILS_SUCCESS = "UPDATE_RCA_HEADER_DETAILS_SUCCESS";

export const UPDATE_ACTION_STATUS = "UPDATE_ACTION_STATUS";
export const UPDATE_ACTION_STATUS_FAIL = "UPDATE_ACTION_STATUS_FAIL";
export const UPDATE_ACTION_STATUS_SUCCESS = "UPDATE_ACTION_STATUS_SUCCESS";

export const UPDATE_RCA_ACTIONS = "UPDATE_RCA_ACTIONS";
export const UPDATE_RCA_ACTIONS_FAIL = "UPDATE_RCA_ACTIONS_FAIL";
export const UPDATE_RCA_ACTIONS_SUCCESS = "UPDATE_RCA_ACTIONS_SUCCESS";

export const UPDATE_RCA_RELATED_ALERTS = "UPDATE_RCA_RELATED_ALERTS";
export const UPDATE_RCA_RELATED_ALERTS_FAIL = "UPDATE_RCA_RELATED_ALERTS_FAIL";
export const UPDATE_RCA_RELATED_ALERTS_SUCCESS = "UPDATE_RCA_RELATED_ALERTS_SUCCESS";

export const UPDATE_RCA_RELATED_RCAS = "UPDATE_RCA_RELATED_RCAS";
export const UPDATE_RCA_RELATED_RCAS_FAIL = "UPDATE_RCA_RELATED_RCAS_FAIL";
export const UPDATE_RCA_RELATED_RCAS_SUCCESS = "UPDATE_RCA_RELATED_RCAS_SUCCESS";

export const UPDATE_RCA_IMPACTED_APPLICATIONS = "UPDATE_RCA_IMPACTED_APPLICATIONS";
export const UPDATE_RCA_IMPACTED_APPLICATIONS_FAIL = "UPDATE_RCA_IMPACTED_APPLICATIONS_FAIL";
export const UPDATE_RCA_IMPACTED_APPLICATIONS_SUCCESS = "UPDATE_RCA_IMPACTED_APPLICATIONS_SUCCESS";

export const DELETE_RCA_BY_ID = "DELETE_RCA_BY_ID";
export const DELETE_RCA_BY_ID_FAIL = "DELETE_RCA_BY_ID_FAIL";
export const DELETE_RCA_BY_ID_SUCCESS = "DELETE_RCA_BY_ID_SUCCESS";

export const CLEAR_RCA_DATA = "CLEAR_RCA_DATA";

